import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Box,
} from '@mui/material';
import { FC, ReactNode } from 'react';

import { useInfoBox } from './useInfoBox';
import { INFO_BOX_HEIGHT_PX, useSxStyles } from './useStyles';

type Props = {
  name: string;
  actionElement?: ReactNode;
  noMargin?: boolean;
  shadowLeft?: boolean;
  height?: number | string;
  open?: boolean;
  hasPin?: boolean;
  isPinned?: boolean;
  onClose?: () => void;
  handleBtnAction?: () => void;
};

export const InfoBox: FC<Props> = ({
  actionElement,
  children,
  name,
  noMargin,
  shadowLeft,
  height = INFO_BOX_HEIGHT_PX,
  open,
  hasPin,
  isPinned,
  onClose,
  handleBtnAction,
}) => {
  const sxStyles = useSxStyles();
  const { handleBtnClose } = useInfoBox({
    onClose,
  });

  return (
    <Box
      sx={{
        ...sxStyles.infoBox,
        ...(noMargin ? sxStyles.infoBoxNoMargin : {}),
      }}
    >
      <Box sx={sxStyles.infoExpansionBox}>
        <Accordion expanded={open || isPinned}>
          <AccordionSummary sx={{ display: 'none' }}></AccordionSummary>
          <AccordionDetails sx={{ padding: 0 }}>
            <Box sx={{ height: height }}>
              <Box sx={sxStyles.infoExpansionBoxHeader}>
                <span>{name}</span>
                {hasPin && (
                  <Box
                    component={'span'}
                    sx={{
                      ...sxStyles.infoExpansionBoxHeaderIcon,
                      ...sxStyles.infoExpansionBoxHeaderIconPin,
                      ...sxStyles.infoExpansionBoxHover,
                      ...(isPinned ? sxStyles.infoExpansionBoxPinned : {}),
                    }}
                    onClick={handleBtnAction}
                  >
                    <i className="fa fa-thumb-tack sfTack"></i>
                  </Box>
                )}
                <Box
                  sx={{
                    ...sxStyles.infoExpansionBoxHeaderIcon,
                    ...(hasPin ? sxStyles.infoExpansionBoxHover : {}),
                  }}
                  onClick={handleBtnClose}
                >
                  <i className="fa fa-times"></i>
                </Box>
              </Box>
              <Box sx={sxStyles.infoExpansionBoxContent}>{children}</Box>
            </Box>
          </AccordionDetails>
        </Accordion>
      </Box>
      <Box
        sx={{
          ...sxStyles.infoBoxBtn,
          ...(shadowLeft ? sxStyles.infoBoxBtnShadowLeft : {}),
        }}
      >
        {actionElement}
      </Box>
    </Box>
  );
};
